"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTimeout = addTimeout;
function addTimeout(promise, _ref) {
  var time = _ref.time,
      reason = _ref.reason;

  return new Promise(function (resolve, reject) {
    var timerId = setTimeout(reject, time, reason);
    var cancel = function cancel() {
      return clearTimeout(timerId);
    };
    promise.then(cancel, cancel);
    promise.then(resolve, reject);
  });
}
//# sourceMappingURL=promise.js.map



//////////////////
// WEBPACK FOOTER
// ../~/music-shared/dist/src/utils/promise.js
// module id = 19
// module chunks = 9 10